export default __webpack_public_path__ + "e4ad21e1e624f8f5cd7c21735a1ecbe5.png";